module.exports = require("npm:opentype.js@0.6.0/src/opentype.js");